import { render, staticRenderFns } from "./rbac-screen.vue?vue&type=template&id=3e4e5960&"
import script from "./rbac-screen.vue?vue&type=script&lang=js&"
export * from "./rbac-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e4e5960')) {
      api.createRecord('3e4e5960', component.options)
    } else {
      api.reload('3e4e5960', component.options)
    }
    module.hot.accept("./rbac-screen.vue?vue&type=template&id=3e4e5960&", function () {
      api.rerender('3e4e5960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/rbac/rbac-screen.vue"
export default component.exports